import { proxy } from 'valtio';

import { type AddFlagProps, type Flag } from '../types';

/**
 * The core manager for handling flags.
 * This can be wired up with local flags state, external flags state, or a no-op implementation.
 */
export abstract class FlagsManager {
  constructor(
    /**
     * A proxy object containing an array of flags.
     *
     * @readonly
     */
    public readonly flags: { data: Flag[] } = proxy({ data: [] })
  ) {}

  /**
   * Adds a new flag with the specified properties.
   */
  abstract addFlag(props: AddFlagProps): void;

  /**
   * Clears all flags.
   */
  abstract clearFlags(): void;

  /**
   * Handles the dismissal of a flag.
   */
  abstract handleFlagDismiss(flagId: number | string): void;
}
